module.exports = __webpack_public_path__ + "img/bumble_promo.cbdb9942.png";